import { render, staticRenderFns } from "./ShowPhotoModal.vue?vue&type=template&id=71929dc8"
import script from "./ShowPhotoModal.vue?vue&type=script&lang=js"
export * from "./ShowPhotoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports